import React from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Skeleton } from '@mui/material'
import useAppointment from '@/v2/hooks/useAppointment'
import { usePatientOfficeNotes } from '@/v2/hooks/patient/usePatientNotes'
import RTAppointments from '@/v2/hooks/subscriptions/messages/RTAppointments'
import AppointmentInformation from '@/v2/modals/appointment/AppointmentDetails/AppointmentInformation'
import MobilePatient from './MobilePatient'
import Typography from '@/v2/components/common/Typography'
import {
  Container,
  Header,
  Content,
  PatientSection,
  AppointmentSection,
} from './styles'

const MobileAppointmentDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const { appointment, loading } = useAppointment({
    appointmentId: id,
  })
  const patientId = appointment?.patient?.id
  const { notes } = usePatientOfficeNotes(patientId)
  const alertNotes = notes?.filter(note => note?.alerts)

  const handleBack = () => {
    if (location.state?.backgroundLocation) {
      navigate(location.state.backgroundLocation.pathname)
    } else {
      navigate(-1)
    }
  }

  const handleEdit = () => {
    navigate(`/v2/appointment/${id}/edit`, {
      state: location.state,
    })
  }

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <Container>
      <RTAppointments appointmentId={id} />
      <Header>
        <Typography variant="h2" fontSize="16px" fontWeight="500">
          Appointment info
        </Typography>
        <IconButton onClick={handleBack} size="small">
          <CloseIcon />
        </IconButton>
      </Header>

      <Content>
        {loading ? (
          <>
            <PatientSection>
              <Skeleton variant="circular" width={60} height={60} />
              <Skeleton variant="rectangular" width="100%" height={100} />
            </PatientSection>
            <AppointmentSection>
              <Skeleton variant="rectangular" width="100%" height={200} />
            </AppointmentSection>
          </>
        ) : (
          <>
            <PatientSection>
              <MobilePatient
                patient={appointment?.patient}
                appointment={appointment}
              />
            </PatientSection>
            <AppointmentSection>
              <AppointmentInformation
                appointment={appointment}
                alertNotes={alertNotes}
                onEditClick={handleEdit}
                onCancel={handleCancel}
              />
            </AppointmentSection>
          </>
        )}
      </Content>
    </Container>
  )
}

export default MobileAppointmentDetails
